import { defineStore } from 'pinia'

import { PRODUCT_BRAND } from '@/brand'

/**
 * The operator panel's brand. The panel is Akaal Creatives' own tool, so it is
 * never white labelled: the brand ships in the build and nothing waits on the
 * API for it.
 */
export const useBrandStore = defineStore('brand', () => {
  const { name, logoUrl, iconUrl } = PRODUCT_BRAND

  /** "Tenants · MDM42" in the tab. */
  function setPageTitle(section: string): void {
    document.title = `${section} · ${name}`
  }

  return { name, logoUrl, iconUrl, setPageTitle }
})
